import { useLocalObservable } from 'mobx-react';
import React, { createContext, ReactNode } from 'react';
import { AppointmentApi, DoctorApi, PatientsApi } from '../../api-client';
import { AuthContext } from '../Auth/auth.provider';
import useStore from '../../helpers/useStore';
import AppointmentStore from './appointmentStore';
import { UserContext } from '../User/User.provider';
import { PatientsContext } from '../Patients/patients.provider';
import { createApiConfig } from '../../api/createApiConfig';



interface AppointmentProviderProps {
  children: ReactNode;
}

export const AppointmentContext = createContext<AppointmentStore | null>(null);
AppointmentContext.displayName = 'AppointmentContext';

export const AppointmentProvider = ({ children }: AppointmentProviderProps) => {
const AuthenticationStore = useStore(AuthContext);
const userStore = useStore(UserContext); // Use UserContext
const patientStore=useStore(PatientsContext);

  const apiClient = new AppointmentApi(createApiConfig());

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const store = useLocalObservable(
    () => new AppointmentStore(apiClient,userStore,AuthenticationStore,patientStore)
  );

  store.apiClient = apiClient;
  // store.getCancelledAppointments().then((res) => { console.log("CancelledAppointmentsdfsf:"); });

  return (
    <AppointmentContext.Provider value={store}>
      {children}
    </AppointmentContext.Provider>
  );
};